import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import React from "react";
import { DepositDataItem } from "@letsbit/malcolmlb";
import { ReactComponent as CopyIcon } from "assets/images/icons/copy-purple.svg";
import { Button } from "@letsbit/milkylb";

import "./styles.scss";

export const DepositData: React.FC<{
  addressData: DepositDataItem[];
  paymentNetworkId: string;
}> = ({ addressData, paymentNetworkId }) => {
  const copyAllDataToClipboard = () => {
    const dataString =
      `Datos para transferencia a LB Finanzas\n\nTipo de transferencia: ${paymentNetworkId}\n\n` +
      addressData.map((field) => `${field.key}: ${field.value}`).join("\n");

    navigator.clipboard.writeText(dataString);
  };

  return (
    <div className="h-full w-1/2 rounded-lg bg-[#FAFAFA] px-4 py-3">
      <div className="deposit-data mb-6 flex items-center justify-between">
        <h1 className="font-['Tomato_Grotesk'] text-3xl font-medium text-[--milkylb-color-secondary-600]">
          <FormattedMessage {...messages.accountToTransfer} />
        </h1>
        {addressData.length !== 0 && (
          <Button
            type="button"
            fill="clear"
            leftIcon={() => <CopyIcon width={16} height={16} />}
            onClick={copyAllDataToClipboard}
            className="letsbit-ui-button-outline-svg-filled ml-6"
          >
            <FormattedMessage {...messages.copyAll} />
          </Button>
        )}
      </div>
      <div className="flex flex-col gap-3">
        {addressData.length !== 0 ? (
          addressData.map((field) => (
            <div className="flex justify-between">
              <h3 className="text-lg text-[--milkylb-color-neutral-600]">
                {field.key}
              </h3>
              <div className="flex items-center gap-4">
                <h3 className="whitespace-pre-wrap text-right text-lg leading-4 text-[--milkylb-color-neutral-400]">
                  {field.value}
                </h3>
                <div className="ripple rounded-xl p-1 duration-200 hover:bg-[--milkylb-color-secondary-100] hover:ease-in">
                  <CopyIcon
                    onClick={() => navigator.clipboard.writeText(field.value)}
                    className="cursor-pointer"
                  />
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="mb-4 flex items-center justify-center text-center">
            <h3 className="text-[--milkylb-color-neutral-600]">
              <FormattedMessage
                {...messages.emptyCase}
                values={{ br: <br /> }}
              />
            </h3>
          </div>
        )}
      </div>
    </div>
  );
};
